/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Pdf_ViewInputs */

const en_read_along_pdf_view = /** @type {(inputs: Read_Along_Pdf_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF view`)
};

const es_read_along_pdf_view = /** @type {(inputs: Read_Along_Pdf_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista PDF`)
};

/**
* | output |
* | --- |
* | "PDF view" |
*
* @param {Read_Along_Pdf_ViewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_pdf_view = /** @type {((inputs?: Read_Along_Pdf_ViewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Pdf_ViewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_pdf_view(inputs)
	return en_read_along_pdf_view(inputs)
});